module.exports = __webpack_public_path__ + "img/icon-43.e82a6804.svg";